import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const CodeTabs = makeShortcode("CodeTabs");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><dl parentName="p"><dt parentName="dl"><inlineCode parentName="dt">{`measurements`}</inlineCode></dt><dd parentName="dl">{``}<em parentName="dd">{`Optional`}</em>{`. An object containing standard/custom measurements with keys signifying the name of the measurement.`}</dd></dl></p>
    <ul>
      <li parentName="ul">{`Standard measurement keys currently supported are from the following list taken from `}<a parentName="li" {...{
          "href": "https://github.com/getsentry/sentry/blob/a8c960a933d2ded5225841573d8fc426a482ca9c/static/app/utils/discover/fields.tsx#L654-L676"
        }}>{`here`}</a>{`.`}</li>
    </ul>
    <div {...{
      "className": "code-tabs-wrapper"
    }}><CodeTabs mdxType="CodeTabs"><CodeBlock language="json" title="" filename="" mdxType="CodeBlock"><div parentName="div" {...{
            "className": "gatsby-highlight",
            "data-language": "json"
          }}><pre parentName="div" {...{
              "className": "language-json"
            }}><code parentName="pre" {...{
                "className": "language-json"
              }}><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`[`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token comment"
                }}>{`// Web`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"fp"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"fcp"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"lcp"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"fid"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"cls"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"ttfb"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"ttfb.requesttime"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`

  `}<span parentName="code" {...{
                  "className": "token comment"
                }}>{`// Mobile`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"app_start_cold"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"app_start_warm"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"frames_total"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"frames_slow"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"frames_frozen"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`

  `}<span parentName="code" {...{
                  "className": "token comment"
                }}>{`// React native`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"frames_slow_rate"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"frames_frozen_rate"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"stall_count"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"stall_total_time"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"stall_longest_time"`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"stall_percentage"`}</span>{`
`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`]`}</span></code></pre></div></CodeBlock></CodeTabs></div>
    <ul>
      <li parentName="ul">{`For the well-known measurements listed above, Sentry automatically infers units. Custom measurements need units to be specified; if the units are missing, Relay will set them to `}<inlineCode parentName="li">{`"none"`}</inlineCode>{` as a default. The full list of supported units is specified on `}<a parentName="li" {...{
          "href": "https://getsentry.github.io/relay/relay_metrics/enum.MetricUnit.html"
        }}>{`Relay's `}<inlineCode parentName="a">{`MetricUnit`}</inlineCode></a>{`. Sentry's event ingestion supports arbitrary custom units, but many SDKs will not expose a generic user-defined unit interface.`}</li>
    </ul>
    <div {...{
      "className": "code-tabs-wrapper"
    }}><CodeTabs mdxType="CodeTabs"><CodeBlock language="json" title="" filename="" mdxType="CodeBlock"><div parentName="div" {...{
            "className": "gatsby-highlight",
            "data-language": "json"
          }}><pre parentName="div" {...{
              "className": "language-json"
            }}><code parentName="pre" {...{
                "className": "language-json"
              }}><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"measurements"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"lcp"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{` `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"value"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token number"
                }}>{`100`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"fp"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{` `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"value"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token number"
                }}>{`123`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"my.custom.metric"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{` `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"value"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token number"
                }}>{`456`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{` `}<span parentName="code" {...{
                  "className": "token property"
                }}>{`"unit"`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`"millisecond"`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`
`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span></code></pre></div></CodeBlock></CodeTabs></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      